// Todo: resolve the currency symbol using the Intl api
export const currencySymbolMap = {
  usd: '$',
  aud: '$',
  zar: 'R',
  gbp: '£',
};

export const DEFAULT_CURRENCY_SYMBOL = '$';
